import { useState } from "react";
import Stack from '@mui/material/Stack';
import listTables from "./tableTitles.json"
import { Alert, Badge, Card, Skeleton, Tooltip } from "antd";
import { formatarData } from "../../../../../function/utilis/function";
import Pagination from '@mui/material/Pagination';



import "./style.css";

export function TabelaOrdensServico({isTable, msgErrorIdClient, loading, listTableFilter, handleTratar, totalRegistro, quantidade, page, handleChangePage}) {
  const [titleTable] = useState(listTables);

  const SkeletonTable = () => {
    return (
      <>
        {[...Array(3)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={40}
          />
        ))}
      </>
    );
  };

  return (
    <>
      <div className="tabela-container">

        <div className="tabela-header-os">
          {titleTable[0].titles.map((item, index) => {
            return (
              <div key={index} className="col">{item.title}</div>
            );
          })}
        </div>


        {isTable && (
          <>
            {msgErrorIdClient && (
              <Stack sx={{ width: "100%" }} spacing={2}>
                <Alert severity="info">{msgErrorIdClient}</Alert>
              </Stack>
            )}

            {/* TABELA */}
            <div className="tabela-grid">
              {loading ? (
                <SkeletonTable />
              ) : (
                <>
                  {listTableFilter.length > 0 ? (
                    listTableFilter.map((ordem, index) => (
                      <Badge.Ribbon
                        key={index}
                        text={ordem.situacao?.nome || "Sem status"}
                        color={
                          ordem.situacao?.nome === "Cancelada"
                            ? "red"
                            : ordem.situacao?.nome === "Processo Concluído"
                              ? "green"
                              : ordem.situacao?.nome === "Inicial"
                                ? "blue"
                                : ordem.fgExecucaoSuspensa === true
                                  ? "rgb(255, 167, 0)"
                                  : "#005a9e"
                        }
                      >
                        <Tooltip title="Tratar Ordem">
                          <Card size="small" hoverable className="tabela-card-padrao" onClick={() => handleTratar(ordem.id)}>
                            <div className="tabela-linha-os">
                              <div className="col">
                                <strong>{ordem.id}</strong>
                              </div>

                              <div className="col">

                                {ordem.cliente?.id === "" ||
                                  ordem.cliente?.id === null ||
                                  ordem.cliente?.id === 0
                                  ? "Não atribuído"
                                  : ordem.cliente?.id}
                              </div>

                              <div className="col">{formatarData(ordem.dataCriacao) || ""}</div>


                              <div className="col">
                                {ordem.tipo.nome ?? "N/A"}
                              </div>

                              <div className="col">

                                {formatarData(ordem.dataSituacao) || ""}
                              </div>

                              <div className="col">
                                <strong>
                                  {ordem.usuarioAtribuicao?.id
                                  ? ordem.usuarioAtribuicao.id
                                  : "Não atribuído"}
                                </strong>
                              </div>


                              {/* <div className="col" style={{ display: "flex", justifyContent: "center" }} onClick={() => handleTratar(ordem.id)}>
                                        <div className="bt-tratar">
                                          <FiLogIn />
                                        </div>

                                      </div>*/}
                            </div>

                            {/* MODAL extra igual ao outro exemplo */}
                            {/**<div
                                className={`modalContact ${openModals[ordem.id] ? "show" : ""
                                  }`}
                              >
                                <div style={{ display: "flex" }}>
                                  <div className="displayFlex margin-botton">
                                    <div className="padding icon-style">
                                      <MdEmail />
                                    </div>
                                    <div className="padding">
                                      <span>{ordem.contato.email}</span>
                                    </div>
                                  </div>

                                  <div className="displayFlex margin-botton">
                                    <div className="padding icon-style">
                                      <FaPhone />
                                    </div>
                                    <div className="padding">
                                      <span>{formatTelefone(ordem.contato.telefone)}</span>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                          </Card>
                        </Tooltip>
                      </Badge.Ribbon>
                    ))
                  ) : (
                    <p>Nenhum resultado encontrado para essa situação.</p>
                  )}
                </>
              )}
            </div>
          </>
        )}

        {loading ? (
          // Mostra Skeleton enquanto carrega
          <>
            <span>Carregando...</span>
          </>
        ) : (
          // Mostra o valor total quando terminar de carregar
          <Stack spacing={1}>
            <Pagination
              count={Math.ceil(totalRegistro / quantidade)} // número total de páginas
              page={page} // página atual
              onChange={handleChangePage} // função de troca de página
              size="small"
            />
          </Stack>
        )}

      </div>
    </>

  );
}
export default TabelaOrdensServico;